import { useAppSelector } from '@/redux/store'
import { selectBingoHasPlayingOrderInRound, selectBingoIsWaiting } from '../redux/bingo.slice'

export function useIsDisplayMinerCountdown() {
  const isWaiting = useAppSelector(selectBingoIsWaiting)
  const hasPlayingOrder = useAppSelector(selectBingoHasPlayingOrderInRound)
  return isWaiting && hasPlayingOrder
}
